import _ from "lodash";
import { Autocomplete, CircularProgress, IconButton, TextField } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import InputBox from "../input/InputBox";
import { PField } from "../input/NestedField";
import { fetchArray } from "entity";
import EntitySearchDialog from "./EntitySearchDialog";
import { fieldHasError, requiredValidator } from "../input/validator";

export default function EntitySearchInput({
    name,
    label,
    required,
    helperText,
    EntityClass,
    initialValue,
    optionLabelField,
    extraQuery,
    onChange,
    onSelectItem,
    loadOnRender,
    autoSelectOne,
    sx,
    ...props
}) {
    const [options, setOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const loading = open && options.length === 0;

    const [searchDialog, setSearchDialog] = useState();

    const labelField = optionLabelField || EntityClass.labelField;
    const realExtraQuery = useMemo(() => extraQuery, [extraQuery]);
    useEffect(() => {
        // console.log('realExtraQuery', realExtraQuery)
        setOptions([]);
        return () => { }
    }, [realExtraQuery])

    const loadOptions = useCallback(async () => {
        // Carrega apenas uma vez.
        if (options.length === 0) {
            // console.log('load')
            let query = await EntityClass.query();
            // let query = await EntityClass.where(labelField, "!=", "");

            if (realExtraQuery) {
                query = realExtraQuery(query);
            }

            const result = await fetchArray(query.get());
            setOptions(result);
        }
    }, [EntityClass, realExtraQuery, options.length]);

    useEffect(() => {
        // Carrega ao abrir auto complete.
        if (open || loadOnRender) {
            loadOptions();
        }
        return () => {            
        }


    }, [loadOptions, open, loadOnRender]);

    function openSearchDialog() {
        loadOptions();
        searchDialog.setOpen(true);
    }

    return (
        <InputBox sx={sx}>
            <PField
                name={name}
                initialValue={initialValue}
                validate={required ? requiredValidator : null}
                onChange={onChange}
            >
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta);

                    if (autoSelectOne && options.length === 2 && !fieldProps.input.value) {

                        fieldProps.input.onChange(options[1])
                    }
                    let optionsUse = [...options] || []
                
                    if (!fieldProps.input.value) {
                        optionsUse.push("")
                    }
                    return (
                        <>
                            <Autocomplete
                                options={optionsUse}
                                getOptionLabel={(option) => _.get(option, labelField) || ""}
                                isOptionEqualToValue={(option, value) => option.uid === value.uid}
                                //
                                renderOption={(props, option) =>
                                    option.uid && _.get(option, labelField) ? (
                                        <li {...props} key={option.uid}>
                                            {_.get(option, labelField)}
                                        </li>
                                    ) : null
                                }
                                //
                                open={open}
                                onOpen={() => setOpen(true)}
                                onClose={() => setOpen(false)}
                                loading={loading}
                                //
                                sx={{ flex: 1 }}
                                forcePopupIcon={false}
                                renderInput={(params) => (
                                    <TextField
                                        label={label}
                                        required={required}
                                        error={hasError}
                                        helperText={hasError ? fieldProps.meta.error : helperText}
                                        variant="standard"
                                        {...params}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    <IconButton onClick={openSearchDialog} sx={{ p: "2px" }}>
                                                        <SearchIcon />
                                                    </IconButton>
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                                //
                                {...fieldProps.input}
                                {...props}
                                onChange={(event, value) => {
                                    // Necessário para passar os valores do MUI para o Final Form imediatamente.
                                    fieldProps.input.onChange(value);
                                    if (onSelectItem) onSelectItem(value)
                                }}
                            />

                            <EntitySearchDialog
                                title={label}
                                columns={EntityClass.searchColumns}
                                data={options}
                                setDialog={setSearchDialog}
                                onClose={(value) => {
                                    fieldProps.input.onChange(value);
                                    if (onSelectItem) onSelectItem(value)
                                }}
                            />
                        </>
                    );
                }}
            </PField>
        </InputBox>
    );
}
